/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 */

/**
 * Browsers have no `setImmediate`, but Grist's client code calls it bare (CursorMonitor, RightPanel, Forms/Field),
 * which throws "setImmediate is not defined". Webpack's ProvidePlugin (buildtools/webpack.config.js) points every
 * free use of `setImmediate` / `clearImmediate` in the client bundle here. A zero-delay timer gives the same order
 * these callers rely on: after the current task.
 */

export function setImmediate(callback: (...args: any[]) => void, ...args: any[]): ReturnType<typeof globalThis.setTimeout> {
  return globalThis.setTimeout(callback, 0, ...args);
}

export function clearImmediate(handle: ReturnType<typeof globalThis.setTimeout> | undefined): void {
  if (handle !== undefined) { globalThis.clearTimeout(handle); }
}
